module.exports = __webpack_public_path__ + "static/media/lazada.df52fdfa.png";